import { dataTestIds } from '../../../config/data-testids';
import { useTranslation } from '../../../providers/i18next';
import { useReturnValue } from '../../../providers/returnValue';
import { convertTextLinks } from '../../../utils/brandingLinks';
import { ExternalLink } from '../../Links';

const LegalText = () => {
  const { txn } = useTranslation();
  const { brandingData } = useReturnValue();
  /* 
    Example: 
    "disclaimer": {
      "key": "AUTH-TOS-PRIVACY-DISCLAIMER-ELI",
      "params": {
        "ws_eli_tos": "https://corp.wonderschool.com/eli-terms",
        "ws_eli_privacy": "https://corp.wonderschool.com/eli-privacy",
        "eli_tos": "https://theearlylearningmarketplace.org/terms/",
        "eli_privacy": "https://theearlylearningmarketplace.org/privacy/"
      }
    },
  */
  const hasBranding = !!brandingData && brandingData?.disclaimer;

  if (hasBranding) {
    return (
      <>
        {convertTextLinks(
          txn(brandingData.disclaimer.key, brandingData.disclaimer.params)
        )}
      </>
    );
  }

  return (
    <>
      {txn('I have read and agree to the')}{' '}
      <ExternalLink
        href="https://www.wonderschool.com/corp/terms"
        data-testid={dataTestIds.legalFooter.termsLink}
      >
        {txn('Terms of Use')}
      </ExternalLink>{' '}
      {txn('and')}{' '}
      <ExternalLink
        href="https://www.wonderschool.com/corp/privacy"
        data-testid={dataTestIds.legalFooter.privacyPolicyLink}
      >
        {txn('Privacy Policy')}
      </ExternalLink>{' '}
      {txn('and consent to be contacted by phone, email or text message.')}
    </>
  );
};

export default LegalText;
